import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute';
import QuestionPickerPage from './pages/QuestionPickerPage';
import TestAssignPage from './pages/TestAssignPage';
import TestDetailPage from './pages/TestDetailPage';
import TestsListPage from './pages/TestsListPage';
import TestWizardPage from './pages/TestWizardPage';
import UnansweredQuestionsPage from './pages/UnansweredQuestionsPage';

/**
 * Маршруты рабочего места «Тесты». `PrivateRoute` без `adminOnly`: проверку роли делает `withAdminOnly`
 * внутри страницы, поэтому сотрудник видит понятный экран, а не молчаливый переход на «/».
 * Статический адрес `new` в react-router важнее `:testId`, порядок записей не влияет.
 * Прежний экран `/admin/tests/:testId/questions` в список не входит и не меняется.
 */
export const testsWorkspaceRoutes = (): React.ReactElement[] => [
  <Route key="list" path="/admin/tests" element={<PrivateRoute><TestsListPage /></PrivateRoute>} />,
  <Route
    key="unanswered"
    path="/admin/tests/unanswered"
    element={<PrivateRoute><UnansweredQuestionsPage /></PrivateRoute>}
  />,
  <Route key="new" path="/admin/tests/new" element={<PrivateRoute><TestWizardPage /></PrivateRoute>} />,
  <Route
    key="new-pick"
    path="/admin/tests/new/questions/add"
    element={<PrivateRoute><QuestionPickerPage target="wizard" /></PrivateRoute>}
  />,
  <Route key="detail" path="/admin/tests/:testId" element={<PrivateRoute><TestDetailPage /></PrivateRoute>} />,
  <Route
    key="pick"
    path="/admin/tests/:testId/questions/add"
    element={<PrivateRoute><QuestionPickerPage target="test" /></PrivateRoute>}
  />,
  <Route key="assign" path="/admin/tests/:testId/assign" element={<PrivateRoute><TestAssignPage /></PrivateRoute>} />,
];
